angular.module('picmonic-common').factory('TwentyFourHourDiscountModal', [
  '$modal',
  '$interval',
  'UserService',
  'SplitTestService',
  '$cookies',
  function ($modal, $interval, UserService, SplitTestService, $cookies) {
    return {
      time: 0,
      hours: null,
      minutes: null,
      seconds: null,
      interval: null,
      check: function () {
        var self = this,
          hours = 24,
          diff = parseInt(Date.now() / 1000) - UserService.user.created_at;
        self.time = 60 * 60 * (hours * 2) - diff;
        return (
          UserService.user.is_trial &&
          !UserService.user.is_referred &&
          diff >= 60 * 60 * hours &&
          diff < 60 * 60 * (hours * 2)
        );
      },
      setCTACookie: function () {
        var expires = new Date();
        expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
        $cookies.put('pls_user_day_2_cta_clicked', 1, { expires: expires });
      },
      calcTime: function () {
        var self = this;
        self.hours = Math.floor(self.time / 60 / 60);
        self.hours = self.hours < 10 ? '0' + self.hours : self.hours;

        self.minutes = Math.floor(self.time / 60) % 60;
        self.minutes = self.minutes < 10 ? '0' + self.minutes : self.minutes;

        self.seconds = Math.floor(self.time % 60);
        self.seconds = self.seconds < 10 ? '0' + self.seconds : self.seconds;
      },
      startTimer: function () {
        var self = this;

        if (self.interval) {
          return;
        }

        self.interval = $interval(function () {
          self.time--;

          if (!self.time && self.interval) {
            $interval.cancel(self.interval);
          }

          self.calcTime();
        }, 1000);

        self.calcTime();
      },
      endTimer: function () {
        if (this.interval) {
          $interval.cancel(this.interval);
        }
      },
      showModal: function () {
        var self = this;

        //const split = SplitTestService.split('twenty-four-hour-discount-modal-design-q122', ['a', 'b']);
        const split = 'b';

        if (typeof smartlook !== 'undefined') {
          smartlook('track', 'twenty-four-hour-discount-modal-opened');
        }

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'twenty-four-hour-discount-modal-opened');
        }

        $modal.open({
          templateUrl:
            split === 'a'
              ? '/templates/modals/twenty-four-hour-discount.html'
              : '/templates/modals/twenty-four-hour-discount-b.html',
          windowClass: 'pls-modal-resources-upgrade pls-modal-twenty-four-hour-discount',
          size: split === 'a' ? 'lg' : 'sm',
          backdrop: 'static',
          controller: [
            '$scope',
            function ($scope) {
              self.startTimer();

              $scope.hours = function () {
                return self.hours;
              };
              $scope.minutes = function () {
                return self.minutes;
              };
              $scope.seconds = function () {
                return self.seconds;
              };

              $scope.setCTACookie = function () {
                self.setCTACookie();
              };
            },
          ],
        });
      },
    };
  },
]);
